import { combineReducers } from "redux";
import userReducer from "./user/user.reducer";
import splashReducer from "./splash/splash.reducer";

const rootReducer = combineReducers({
    user: userReducer,
    splash: splashReducer,
    // menu: menuReducer,
});

export default rootReducer;
